var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.75C15.4228 24.75 17.7912 24.0315 19.8057 22.6855C21.8202 21.3394 23.3904 19.4263 24.3175 17.1879C25.2447 14.9495 25.4873 12.4864 25.0146 10.1101C24.542 7.73387 23.3753 5.55112 21.6621 3.83793C19.9489 2.12474 17.7661 0.958039 15.3899 0.48537C13.0136 0.0127017 10.5505 0.255292 8.31213 1.18247C6.07373 2.10964 4.16055 3.67975 2.8145 5.69425C1.46845 7.70875 0.75 10.0772 0.75 12.5C0.75 15.7489 2.04062 18.8647 4.33794 21.162C6.63526 23.4594 9.7511 24.75 13 24.75ZM7.13138 11.8814C7.29546 11.7173 7.51798 11.6252 7.75 11.6252C7.98202 11.6252 8.20454 11.7173 8.36863 11.8814L11.25 14.7627L17.6314 8.38136C17.7964 8.22198 18.0174 8.13378 18.2469 8.13577C18.4763 8.13777 18.6957 8.22979 18.858 8.39202C19.0202 8.55425 19.1122 8.77372 19.1142 9.00314C19.1162 9.23256 19.028 9.45359 18.8686 9.61861L11.8686 16.6186C11.7045 16.7826 11.482 16.8748 11.25 16.8748C11.018 16.8748 10.7955 16.7826 10.6314 16.6186L7.13138 13.1186C6.96734 12.9545 6.87519 12.732 6.87519 12.5C6.87519 12.268 6.96734 12.0454 7.13138 11.8814V11.8814Z",
    fill: "url(#paint0_linear_189_301)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_301",
    x1: 0.75,
    y1: 12.5,
    x2: 25.25,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E3C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8c111fce.svg";
export { ForwardRef as ReactComponent };